import type { StructureName } from "src/api";

// TODO: THIS IS ALL TEMPORARY, SOON THESE DEFINTIIONS WILL BE POPULATED WITH EVERYTHING DATA ORIENTED
// ABOUT STRUCTURES SUCH AS THEIR MODELS, THEIR SOUNDS FOR DIFFERENT EVENTS, AND ETC.
// Structure.ts is simply a consumer of this data interface to create a structure
export interface StructureDefinition {
  placeholderColor: string;
  placeholderHeight: number;
}

export const STRUCTURE_DEFINITIONS: Record<StructureName, StructureDefinition> = {
  store: { placeholderColor: "#000000", placeholderHeight: 0.2 },
  turret: { placeholderColor: "#FF0000", placeholderHeight: 0.4 },
  altar: { placeholderColor: "#00FF00", placeholderHeight: 0.6 },
  relic: { placeholderColor: "#0000FF", placeholderHeight: 0.8 },
  banner: { placeholderColor: "#FFFF00", placeholderHeight: 1.0 },
  keystone: { placeholderColor: "#FF00FF", placeholderHeight: 1.2 },
  well: { placeholderColor: "#00FFFF", placeholderHeight: 1.4 },
  research: { placeholderColor: "#FFFFFF", placeholderHeight: 1.6 }
};

